import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { JobWorkspaceFormPanel } from "@/features/jobs/components";
import { jobQueryOptions } from "@/services/job";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/form",
)({
	component: JobWorkspaceFormTab,
});

function JobWorkspaceFormTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/form",
	});
	const jobById = useQuery(
		jobQueryOptions.detail(params.jobId, { organizationId: params.orgId }),
	);

	return (
		<JobWorkspaceFormPanel
			job={jobById.data}
			jobId={params.jobId}
			organizationId={params.orgId}
			isJobPending={jobById.isPending}
		/>
	);
}
